import React from 'react';

import { Bed } from '@travel/icons/service';
import type { ProviderInformation } from '@travel/traveler-core/types/providerInformation';

import { Translate } from '../../../../core/translate';

import styles from './basicInformation.module.scss';

export default function TotalRoomNumber(props: {
  provider: ProviderInformation;
  isMobile: boolean;
}) {
  const { provider, isMobile } = props;
  if (!provider.totalRooms || provider.totalRooms === 0) {
    return null;
  }

  return (
    <div className={styles.rowItem}>
      <div className={styles.leftContent}>
        {isMobile && <Translate id="Provider_Info.Basic_Info.Hotel_Info.Size" />}
        {!isMobile && (
          <>
            <Bed size={16} />
            <span className={styles.totalRoomText}>
              <Translate id="Provider_Info.Basic_Info.Hotel_Info.Size" />
            </span>
          </>
        )}
      </div>
      <div className={styles.rightContent} data-testid="basicInformation-totalRoom">
        {provider.totalRooms}
      </div>
    </div>
  );
}
